import { InspectionMetricRenderer } from 'features/inbox/components/inspectionCards/InspectionMetricRenderer'
import { getMetricsForInspection } from 'features/inbox/config/inspectionMetrics'
import { EnrichedGeckoInspection } from 'features/inbox/types/types'
import React, { memo, useMemo } from 'react'
import styled from 'styled-components'

const LeftMetrics = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  flex: 1;
`

const RightMetrics = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  flex: 1;
`

interface InspectionMetricsDisplayProps {
  inspection: EnrichedGeckoInspection
}

const InspectionMetricsDisplayBase: React.FC<InspectionMetricsDisplayProps> = ({
  inspection,
}) => {
  const { leftMetrics, rightMetrics } = useMemo(() => {
    const metrics = getMetricsForInspection(inspection)
    const leftMetrics = metrics.slice(0, Math.ceil(metrics.length / 2))
    const rightMetrics = metrics.slice(Math.ceil(metrics.length / 2))
    return { leftMetrics, rightMetrics }
  }, [inspection])

  return (
    <>
      <LeftMetrics>
        {leftMetrics.map((metric) => (
          <InspectionMetricRenderer
            key={metric.key}
            metric={metric}
            inspection={inspection}
          />
        ))}
      </LeftMetrics>
      <RightMetrics>
        {rightMetrics.map((metric) => (
          <InspectionMetricRenderer
            key={metric.key}
            metric={metric}
            inspection={inspection}
          />
        ))}
      </RightMetrics>
    </>
  )
}

export const InspectionMetricsDisplay = memo(InspectionMetricsDisplayBase)
